var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{ref:"suggestionItem",staticClass:"suggestionItem",class:{ 'suggestionItem--selected': _vm.isSelected },on:{"click":_vm.onClick}},_vm._l((_vm.highlight(_vm.wholeText)),function(h,index){return _c('span',{key:index,class:{ 'suggestionItem--highlight': h.isHighlight }},[_vm._v(_vm._s(h.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }